import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { setSessionInvalidHandler } from './lib/api';
import { useAuthStore } from './stores/auth';
import './style.css';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
let redirectingToLogin = false;
setSessionInvalidHandler((reason) => {
  if (redirectingToLogin) return;
  redirectingToLogin = true;
  useAuthStore().invalidarSesion();
  void router.replace({ name: 'login', query: { reason } }).finally(() => {
    redirectingToLogin = false;
  });
});
app.use(router);
app.mount('#app');
